let state = {
    SICPO_PaginaWeb_AltaDeContenido_mostrarFormularios: false,
    SICPO_Catalogos_007PaginasWeb: {},
    SICPO_Catalogos_008SeccionesDeLaPaginaWeb: {},
    SICPO_Catalogos_006Submenus: {},
    SICPO_Catalogos_004Menus: {},
    SICPO_Catalogos_SubMenuAnterior: {},
    // intranet
    SICPO_Catalogos_024SeccionesDeIntranet: {},
    SICPO_Catalogos_029PaginasDeIntranet: {},
    SICPO_Catalogos_030AreasDeIntranet: {},
    SICPO_Catalogos_031TiposClinicasIntranet: {},
    SICPO_Catalogos_025ContenidosDeIntranet: {},
    // fin intranet
    SICPO_PaginaWeb_AltaDeContenido_tipoDeFormulario: -1,
    SICPO_PaginaWeb_AltaDeContenido_camposRequeridosFormulario: {},
    SICPO_PaginaWeb_AltaDeContenido_mostrarPasoTres: false,
    SICPO_PaginaWeb_AltaDeContenido_cambioDeFormulario: false,
    SICPO_PaginaWeb_AltaDeContenido_cambioDeFormularioInput: false,
    SICPO_PaginaWeb_AltaDeContenido_listaContenidoOriginal: [],
    SICPO_PaginaWeb_AltaDeContenido_cambioOrdenlistaContenidos: false,
    SICPO_PaginaWeb_AltaDeContenido_punteroDeContenidoActual: {},
    SICPO_Micrositio_MenuRuta: '',
    SICPO_Micrositio_RutaVideo:{},  
    SICPO_Catalogo_001PaginaInicio:{},
    SICPO_Catalogo_005TiposPosicion:{},
    SICPO_Catalogo_013PaginaMicrositio:{},
    SICPO_Catalogo_014SeccionMicrositio:{},
    SICPO_Catalogo_015ContenidoMicrositio:{},
    SICPO_Catalogo_FormatoDeSeccion:{},
    SICPO_Catalogo_TipoDeFormulario:{},
    SICPO_Micrositio_AltaDeContenido_listaContenidoOriginal: [],
    SICPO_Micrositio_AltaDeContenido_cambioOrdenlistaContenidos: false,
    SICPO_Micrositio_Edicion_mostrarTablaDeContenidos: false,
    SICPO_Micrositio_establecerPunteroDeContenidoActual:{},
    SICPO_Micrositio_establecerOrdenAlfabetico:false,
    SICPO_Micrositio_ComunicadosOrden:[],
    SICPO_Micrositio_Login:false
   
}

let getters = {
  Get_SICPO_Catalogos_SubMenuAnterior:state =>{
    return state.SICPO_Catalogos_SubMenuAnterior;
  },
    Get_SICPO_PaginaWeb_AltaDeContenido_mostrarFormularios: state => {
        return state.SICPO_PaginaWeb_AltaDeContenido_mostrarFormularios;
    },
    Get_SICPO_PaginaWeb_AltaDeContenido_tipoDeFormulario: state => {
        return state.SICPO_PaginaWeb_AltaDeContenido_tipoDeFormulario;
    },
    Get_SICPO_PaginaWeb_AltaDeContenido_mostrarPasoTres: state => {
        return state.SICPO_PaginaWeb_AltaDeContenido_mostrarPasoTres;
    },
    Get_SICPO_PaginaWeb_AltaDeContenido_cambioDeFormulario: state => {
        return state.SICPO_PaginaWeb_AltaDeContenido_cambioDeFormulario;
    },
    Get_SICPO_PaginaWeb_AltaDeContenido_cambioDeFormularioInput: state => {
        return state.SICPO_PaginaWeb_AltaDeContenido_cambioDeFormularioInput;
    },
    Get_SICPO_Catalogos_007PaginasWeb: state => {
        return state.SICPO_Catalogos_007PaginasWeb;
    },
    Get_SICPO_Catalogos_008SeccionesDeLaPaginaWeb: state => {
        return state.SICPO_Catalogos_008SeccionesDeLaPaginaWeb;
    },
    Get_SICPO_Catalogos_005TiposPosicion: state => {
      return state.SICPO_Catalogo_005TiposPosicion;
    },
    Get_SICPO_Catalogos_006Submenus: state => {
      return state.SICPO_Catalogos_006Submenus;
    },
    Get_SICPO_Catalogos_004Menus:state =>{
      return state.SICPO_Catalogos_004Menus;
    },
    Get_SICPO_PaginaWeb_AltaDeContenido_camposRequeridosFormulario: state => {
        return state.SICPO_PaginaWeb_AltaDeContenido_camposRequeridosFormulario;
    },
    Get_SICPO_PaginaWeb_AltaDeContenido_listaContenidoOriginal: state => {
        return state.SICPO_PaginaWeb_AltaDeContenido_listaContenidoOriginal;
    },
    Get_SICPO_PaginaWeb_AltaDeContenido_cambioOrdenlistaContenidos: state => {
        return state.SICPO_PaginaWeb_AltaDeContenido_cambioOrdenlistaContenidos;
    },
    Get_SICPO_PaginaWeb_AltaDeContenido_punteroDeContenidoActual: state => {
        return state.SICPO_PaginaWeb_AltaDeContenido_punteroDeContenidoActual;
     },
    Get_SICPO_Micrositio_MenuRuta: state => {
      return state.SICPO_Micrositio_MenuRuta;
    
    },
    Get_SICPO_Micrositio_RutaVideo: state => {
      return state.SICPO_Micrositio_RutaVideo;
      
    },
    Get_SICPO_Catalogos_001PaginaInicio: state => {
      return state.SICPO_Catalogo_001PaginaInicio;
  },
    Get_SICPO_Catalogos_013PaginaMicrositio: state => {
      return state.SICPO_Catalogo_013PaginaMicrositio;
  },
  Get_SICPO_Catalogo_014SeccionMicrositio: state => {
    return state.SICPO_Catalogo_014SeccionMicrositio;
},
Get_SICPO_Catalogo_015ContenidoMicrositio: state => {
  return state.SICPO_Catalogo_015ContenidoMicrositio;
},
Get_SICPO_Catalogo_FormatoDeSeccion: state => {
  return state.SICPO_Catalogo_FormatoDeSeccion;
},
Get_SICPO_Catalogo_TipoDeFormulario: state => {
  return state.SICPO_Catalogo_TipoDeFormulario;
},
Get_SICPO_Micrositio_AltaDeContenido_listaContenidoOriginal:state => {
  return state.SICPO_Micrositio_AltaDeContenido_listaContenidoOriginal;
},
Get_SICPO_Micrositio_AltaDeContenido_cambioOrdenlistaContenidos: state => {
  return state.SICPO_Micrositio_AltaDeContenido_cambioOrdenlistaContenidos;
},
Get_SICPO_Micrositio_Edicion_mostrarTablaDeContenidos: state => {
  return state.SICPO_Micrositio_Edicion_mostrarTablaDeContenidos;
},
Get_SICPO_Micrositio_establecerPunteroDeContenidoActual:state =>{
  return state.SICPO_Micrositio_establecerPunteroDeContenidoActual;
},
Get_SICPO_Micrositio_establecerOrdenAlfabetico:state =>{
  return state.SICPO_Micrositio_establecerOrdenAlfabetico;
},
Get_SICPO_Micrositio_ComunicadosOrden:state =>{
  return state.SICPO_Micrositio_ComunicadosOrden;
},
  // intranet
  Get_SICPO_Catalogos_024SeccionesDeIntranet: state => {
    return state.SICPO_Catalogos_024SeccionesDeIntranet;
  },
  Get_SICPO_Catalogos_029PaginasDeIntranet: state => {
    return state.SICPO_Catalogos_029PaginasDeIntranet;
  },
  Get_SICPO_Catalogos_030AreasDeIntranet: state => {
    return state.SICPO_Catalogos_030AreasDeIntranet;
  },
  Get_SICPO_Catalogos_031TiposClinicasIntranet: state => {
    return state.SICPO_Catalogos_031TiposClinicasIntranet;
  },
  Get_SICPO_Catalogos_025ContenidosDeIntranet: state => {
    return state.SICPO_Catalogos_025ContenidosDeIntranet;
  },
  Get_SICPO_Micrositio_Login: state => {
    return state.SICPO_Micrositio_Login;
  },
  // fin intranet
}

let mutations = {
  M_SICPO_Catalogos_SubMenuAnterior(state,data){
    state.SICPO_Catalogos_SubMenuAnterior = data;
  },
    M_SICPO_PaginaWeb_AltaDeContenido_establecerMostrarFormularios(state, data) {
        state.SICPO_PaginaWeb_AltaDeContenido_mostrarFormularios = data;
    },
    M_SICPO_PaginaWeb_AltaDeContenido_establecerTipoDeFormulario(state, data) {
        state.SICPO_PaginaWeb_AltaDeContenido_tipoDeFormulario = data;
    },
    M_SICPO_PaginaWeb_AltaDeContenido_establecerMostrarPasoTres(state, data) {
        state.SICPO_PaginaWeb_AltaDeContenido_mostrarPasoTres = data;
    },
    M_SICPO_PaginaWeb_AltaDeContenido_establecerCambioDeFormulario(state, data) {
        state.SICPO_PaginaWeb_AltaDeContenido_cambioDeFormulario = data;
    },
    M_SICPO_PaginaWeb_AltaDeContenido_establecerCambioDeFormularioInput(state, data) {
        state.SICPO_PaginaWeb_AltaDeContenido_cambioDeFormularioInput = data;
    },
    M_SICPO_Catalogos_establecer005TiposPosicion(state, data) {
        state.SICPO_Catalogo_005TiposPosicion[data.llave] = data.valor;
    },
    M_SICPO_Catalogos_establecer007PaginasWeb(state, data) {
        state.SICPO_Catalogos_007PaginasWeb[data.llave] = data.valor;
    },
    M_SICPO_Catalogos_establecer008SeccionesDeLaPaginaWeb(state, data) {
        state.SICPO_Catalogos_008SeccionesDeLaPaginaWeb[data.llave] = data.valor;
    },
    M_SICPO_Catalogos_establecer006Submenus(state, data) {
      state.SICPO_Catalogos_006Submenus[data.llave] = data.valor;
    },
    M_SICPO_Catalogos_establecer004Menus(state, data) {
      state.SICPO_Catalogos_004Menus[data.llave] = data.valor;
    },
    M_SICPO_PaginaWeb_AltaDeContenido_establecerCamposRequeridosFormulario(state, data) {
        state.SICPO_PaginaWeb_AltaDeContenido_camposRequeridosFormulario = data;
    },
    M_SICPO_PaginaWeb_AltaDeContenido_establecerListaContenidoOriginal(state, data) {
        state.SICPO_PaginaWeb_AltaDeContenido_listaContenidoOriginal = data;
    },
    M_SICPO_PaginaWeb_AltaDeContenido_establecerCambioOrdenlistaContenidos(state, data) {
        state.SICPO_PaginaWeb_AltaDeContenido_cambioOrdenlistaContenidos = data;
    },
    M_SICPO_PaginaWeb_AltaDeContenido_establecerPunteroDeContenidoActual(state, data) {
        state.SICPO_PaginaWeb_AltaDeContenido_punteroDeContenidoActual = data;
  },
  M_SICPO_Micrositio_MenuRuta(state,data) {
    state.SICPO_Micrositio_MenuRuta = data;
  },
  M_SICPO_Micrositio_RutaVideo(state,data) {
    state.SICPO_Micrositio_RutaVideo = data;   
  },
  M_SICPO_Catalogos_001PaginaInicio(state, data) {
    state.SICPO_Catalogo_001PaginaInicio[data.llave] = data.valor;
},
  M_SICPO_Catalogos_013PaginaMicrositio(state, data) {
    state.SICPO_Catalogo_013PaginaMicrositio[data.llave] = data.valor;
},
M_SICPO_Catalogo_014SeccionMicrositio(state, data) {
  state.SICPO_Catalogo_014SeccionMicrositio[data.llave] = data.valor;
},
M_SICPO_Catalogo_015ContenidoMicrositio(state, data) {
  state.SICPO_Catalogo_015ContenidoMicrositio[data.llave] = data.valor;
},
M_SICPO_Catalogo_FormatoDeSeccion(state, data) {
  state.SICPO_Catalogo_FormatoDeSeccion = data;
},
M_SICPO_Catalogo_TipoDeFormulario(state, data) {
  state.SICPO_Catalogo_TipoDeFormulario = data;
},
M_SICPO_Micrositio_AltaDeContenido_listaContenidoOriginal(state, data) {
  state.SICPO_Micrositio_AltaDeContenido_listaContenidoOriginal = data;
},
M_SICPO_Micrositio_AltaDeContenido_establecerCambioOrdenlistaContenidos(state, data) {
  state.SICPO_Micrositio_AltaDeContenido_cambioOrdenlistaContenidos = data;
},
M_SICPO_Micrositio_Edicion_mostrarTablaDeContenidos(state, data) {
  state.SICPO_Micrositio_Edicion_mostrarTablaDeContenidos = data;
},
M_SICPO_Micrositio_establecerPunteroDeContenidoActual(state,data){
  state.SICPO_Micrositio_establecerPunteroDeContenidoActual = data;
},
M_SICPO_Micrositio_establecerOrdenAlfabetico(state,data){
  state.SICPO_Micrositio_establecerOrdenAlfabetico = data;
},
M_SICPO_Micrositio_ComunicadosOrden(state,data){
state.SICPO_Micrositio_ComunicadosOrden = data;
},
M_SICPO_Micrositio_Login(state,data){
  state.SICPO_Micrositio_Login = data;
},
  // intranet
  M_SICPO_Catalogos_establecer024SeccionesDeIntranet(state, data) {
    state.SICPO_Catalogos_024SeccionesDeIntranet[data.llave] = data.valor;
  },
  M_SICPO_Catalogos_establecer029PaginasDeIntranet(state, data) {
    state.SICPO_Catalogos_029PaginasDeIntranet[data.llave] = data.valor;
  },
  M_SICPO_Catalogos_establecer030AreasDeIntranet(state, data) {
    state.SICPO_Catalogos_030AreasDeIntranet[data.llave] = data.valor;
  },
  M_SICPO_Catalogos_establecer031TiposClinicasIntranet(state, data) {
    state.SICPO_Catalogos_031TiposClinicasIntranet[data.llave] = data.valor;
  },
  M_SICPO_Catalogos_establecer025ContenidosDeIntranet(state, data) {
    state.SICPO_Catalogos_025ContenidosDeIntranet[data.llave] = data.valor;
  }
  // fin intranet
}

let actions = {
  A_SICPO_Catalogos_SubMenuAnterior:({commit},data)=>{
    commit('M_SICPO_Catalogos_SubMenuAnterior',data)
  },
  A_SICPO_PaginaWeb_AltaDeContenido_establecerMostrarFormularios: ({ commit }, data) => {
    commit('M_SICPO_PaginaWeb_AltaDeContenido_establecerMostrarFormularios', data)
  },
  A_SICPO_PaginaWeb_AltaDeContenido_establecerTipoDeFormulario: ({ commit }, data) => {
    commit('M_SICPO_PaginaWeb_AltaDeContenido_establecerTipoDeFormulario', data)
  },
  A_SICPO_PaginaWeb_AltaDeContenido_establecerMostrarPasoTres: ({ commit }, data) => {
    commit('M_SICPO_PaginaWeb_AltaDeContenido_establecerMostrarPasoTres', data)
  },
  A_SICPO_PaginaWeb_AltaDeContenido_establecerCambioDeFormulario: ({ commit }, data) => {
    commit('M_SICPO_PaginaWeb_AltaDeContenido_establecerCambioDeFormulario', data)
  },
  A_SICPO_PaginaWeb_AltaDeContenido_establecerCambioDeFormularioInput: ({ commit }, data) => {
    commit('M_SICPO_PaginaWeb_AltaDeContenido_establecerCambioDeFormularioInput', data)
  },
  A_SICPO_Catalogos_establecer007PaginasWeb: ({ commit }, data) => {
    commit('M_SICPO_Catalogos_establecer007PaginasWeb', data)
  },
  A_SICPO_Catalogos_establecer008SeccionesDeLaPaginaWeb: ({ commit }, data) => {
    commit('M_SICPO_Catalogos_establecer008SeccionesDeLaPaginaWeb', data)
  },
  A_SICPO_Catalogos_establecer006Submenus: ({ commit }, data) => {
    commit('M_SICPO_Catalogos_establecer006Submenus', data)
  },
  A_SICPO_Catalogos_establecer005TiposPosicion: ({ commit }, data) => {
    commit('M_SICPO_Catalogos_establecer005TiposPosicion', data)
  },
  A_SICPO_Catalogos_establecer004Menus: ({ commit }, data) => {
    commit('M_SICPO_Catalogos_establecer004Menus', data)
  },
  A_SICPO_PaginaWeb_AltaDeContenido_establecerCamposRequeridosFormulario: ({ commit }, data) => {
    commit('M_SICPO_PaginaWeb_AltaDeContenido_establecerCamposRequeridosFormulario', data)
  },
  A_SICPO_PaginaWeb_AltaDeContenido_establecerListaContenidoOriginal: ({ commit }, data) => {
    commit('M_SICPO_PaginaWeb_AltaDeContenido_establecerListaContenidoOriginal', data)
  },
  A_SICPO_PaginaWeb_AltaDeContenido_establecerCambioOrdenlistaContenidos: ({ commit }, data) => {
    commit('M_SICPO_PaginaWeb_AltaDeContenido_establecerCambioOrdenlistaContenidos', data)
  },
  A_SICPO_PaginaWeb_AltaDeContenido_establecerPunteroDeContenidoActual: ({ commit }, data) => {
    commit('M_SICPO_PaginaWeb_AltaDeContenido_establecerPunteroDeContenidoActual', data)
  },
  A_SICPO_Micrositio_MenuRuta: ({ commit }, data) => {
    commit('M_SICPO_Micrositio_MenuRuta',data)
  },
  A_SICPO_Micrositio_RutaVideo: ({ commit }, data) => {
    commit('M_SICPO_Micrositio_RutaVideo',data)
  },
  A_SICPO_Catalogo_001PaginaInicio: ({ commit }, data) => {
    commit('M_SICPO_Catalogos_001PaginaInicio',data)
  },
  A_SICPO_Catalogo_013PaginaMicrositio: ({ commit }, data) => {
    commit('M_SICPO_Catalogos_013PaginaMicrositio',data)
  },
  A_SICPO_Catalogo_014SeccionMicrositio: ({ commit }, data) => {
    commit('M_SICPO_Catalogo_014SeccionMicrositio',data)
  },
  A_SICPO_Catalogo_015ContenidoMicrositio: ({ commit }, data) => {
    commit('M_SICPO_Catalogo_015ContenidoMicrositio',data)
  },
  A_SICPO_Catalogo_FormatoDeSeccion: ({ commit }, data) => {
    commit('M_SICPO_Catalogo_FormatoDeSeccion',data)
  },
  A_SICPO_Catalogo_TipoDeFormulario: ({ commit }, data) => {
    commit('M_SICPO_Catalogo_TipoDeFormulario',data)
  },
  A_SICPO_Micrositio_AltaDeContenido_listaContenidoOriginal: ({ commit }, data) => {
    commit('M_SICPO_Micrositio_AltaDeContenido_listaContenidoOriginal', data)
  },
  A_SICPO_Micrositio_AltaDeContenido_establecerCambioOrdenlistaContenidos: ({ commit }, data) => {
    commit('M_SICPO_Micrositio_AltaDeContenido_establecerCambioOrdenlistaContenidos', data)
  },
  A_SICPO_Micrositio_Edicion_mostrarTablaDeContenidos: ({ commit }, data) => {
    commit('M_SICPO_Micrositio_Edicion_mostrarTablaDeContenidos', data)
  },
  A_SICPO_Micrositio_establecerPunteroDeContenidoActual: ({ commit }, data) => {
    commit('M_SICPO_Micrositio_establecerPunteroDeContenidoActual', data)
  }, 
  A_SICPO_Micrositio_establecerOrdenAlfabetico: ({ commit }, data) => {
    commit('M_SICPO_Micrositio_establecerOrdenAlfabetico', data)
  }, 
  A_SICPO_Micrositio_ComunicadosOrden:({commit},data)=>{
    commit('M_SICPO_Micrositio_ComunicadosOrden',data)
  },
  A_SICPO_Micrositio_Login:({commit},data)=>{
    commit('M_SICPO_Micrositio_Login',data)
  },
  // intranet
  A_SICPO_Catalogos_establecer024SeccionesDeIntranet: ({ commit }, data) => {
    commit('M_SICPO_Catalogos_establecer024SeccionesDeIntranet', data)
  },
  A_SICPO_Catalogos_establecer029PaginasDeIntranet: ({ commit }, data) => {
    commit('M_SICPO_Catalogos_establecer029PaginasDeIntranet', data)
  },
  A_SICPO_Catalogos_establecer030AreasDeIntranet: ({ commit }, data) => {
    commit('M_SICPO_Catalogos_establecer030AreasDeIntranet', data)
  },
  A_SICPO_Catalogos_establecer031TiposClinicasIntranet: ({ commit }, data) => {
    commit('M_SICPO_Catalogos_establecer031TiposClinicasIntranet', data)
  },
  A_SICPO_Catalogos_establecer025ContenidosDeIntranet: ({ commit }, data) => {
    commit('M_SICPO_Catalogos_establecer025ContenidosDeIntranet', data)
  }
  // fin intranet
}

const SICPO = {
    State: state,
    Getters: getters,
    Mutations: mutations,
    Actions: actions
}
export default SICPO;



// WEBPACK FOOTER //
// ./src/store/SICPO.js